// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__mwv2n","toggle":"styles_toggle__1zniU","preview":"styles_preview__1zhfB"};